/**
 * D5 (Heitor, 12/10/2026): "Ganhei"/"Perdi" grava o desfecho E encerra o acompanhamento. Antes encerrava mesmo quando o
 * desfecho não gravava (rede fora, servidor recusando): o item ficava `encerrada` sem desfecho e sumia do Cadastrar e do
 * Monitorar, e o placar perdia o resultado. Agora só encerra quando o desfecho gravou, ou no caso em que o backend
 * recusa porque o desfecho JÁ foi capturado do PNCP (documento oficial; o resultado existe).
 *
 * Enquanto o backend não devolve um código próprio para esse caso, ele é reconhecido pela mensagem do 400
 * (procurement.service.ts, registrarDesfechoManual): "…já teve o desfecho … capturado do resultado publicado no PNCP".
 */
export const CODIGO_JA_CAPTURADO = 'DESFECHO_JA_CAPTURADO';

export function desfechoJaCapturado(e: any): boolean {
  const dados = e?.response?.data;
  if (dados?.code === CODIGO_JA_CAPTURADO) return true;
  const msg = Array.isArray(dados?.message) ? dados.message.join(' ') : String(dados?.message || '');
  return e?.response?.status === 400 && /capturado do resultado\s+publicado no PNCP/i.test(msg);
}

export function fraseDoDesfechoQueNaoGravou(e: any): string {
  const dados = e?.response?.data;
  const motivo = (Array.isArray(dados?.message) ? dados.message.join('; ') : dados?.message)
    || (e?.request && !e?.response ? 'o servidor não respondeu' : e?.message || 'erro desconhecido');
  return `Não encerrei: o desfecho não gravou (${motivo}). O item segue aberto; tente de novo.`;
}
